import type { GraphQLFormattedError } from 'graphql'

type GraphQLErrorsContainer = {
  errors: readonly GraphQLFormattedError[]
}

function isCombinedGraphQLErrors(error: unknown): error is GraphQLErrorsContainer {
  return (
    typeof error === 'object' &&
    error !== null &&
    'errors' in error &&
    'name' in error &&
    (error as { name: string }).name === 'CombinedGraphQLErrors' &&
    Array.isArray((error as GraphQLErrorsContainer).errors)
  )
}

export function getGraphQLErrors(error: unknown): readonly GraphQLFormattedError[] {
  if (!isCombinedGraphQLErrors(error)) return []

  return error.errors
}

export function hasGraphQLErrorCode(error: unknown, code: string): boolean {
  return getGraphQLErrors(error).some((graphqlError) => graphqlError.extensions?.code === code)
}
